import { SportState, type SportDto } from '~/shared/api/generated';

type WithState = Pick<SportDto, 'state'>;

export const isSportOpen = (sport: WithState): boolean => sport.state === SportState.OPEN;

export const isSportShown = (sport: WithState): boolean => sport.state !== SportState.DISABLED;

export const SPORT_STATE_LABEL: Record<SportState, string> = {
  [SportState.OPEN]: 'Открыт',
  [SportState.BOOKING_CLOSED]: 'Приём закрыт',
  [SportState.DISABLED]: 'Выключен',
};
